import React, {useMemo, useState, useEffect, useContext, useRef} from "react";
import {CSSTransition} from "react-transition-group";
import {SlideDown} from "react-slidedown";
import 'react-slidedown/lib/slidedown.css'
import "./LeftSidebar.less";
import {API_KEY} from "../../default_informations/api_key";
import {Context} from "../Context/MatchesContext";
import "../../animation.less";

function LeftSidebar() {
    const apiKey = API_KEY;
    const [proMatches, setProMatches] = useState([]);
    const [proLeagues, setProLeagues] = useState([]);
    const [showSidebar, setShowSidebar] = useState(false);
    const sidebarMenu = useRef(null);
    const {getId} = useContext(Context);

    useMemo(() => {
        fetch(`https://api.opendota.com/api/proMatches?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => {
                let match_count = 0;
                let matches_arr = result.filter(item => {
                    /*
                    let start_date = item.start_time;
                    let start_match = new Date(start_date * 1000);
                    let year = start_match.getFullYear();
                    let month = start_match.getMonth() + 1;
                    if (month < 10) month = `0${month}`;
                    let date = start_match.getDate();
                    if (date < 10) date = `0${date}`;

                    let match_date = `${date}.${month}.${year}`;
                    let date_now = `${new Date().getDate()}.${new Date().getMonth() + 1}.${new Date().getFullYear()}`;
                    */

                    if (Boolean(item.dire_team_id) && Boolean(item.radiant_team_id && Boolean(item.dire_name) && Boolean(item.radiant_name)) && (match_count < 24)) {
                        match_count++;
                        return item;
                    }
                    return null;
                });
                setProMatches(matches_arr);
            })
    }, [apiKey]);

    useEffect(() => {
        if (Boolean(proMatches.length)) {
            let arr = [];
            let unique_arr = [];

            for (let item of proMatches) {
                item.active = false;
                if (!arr.includes(item.leagueid)) {
                    arr.push(item.leagueid);
                    unique_arr.push(item)
                }
            }
            setProLeagues(unique_arr);
        }
    }, [proMatches]);

    useEffect(() => {
        setShowSidebar(true);

        return (() => {
            setShowSidebar(false);
        })
    }, []);

    function getMatchesCount(arr, id) {
        let league_arr = arr.filter(item => {
            if (item.leagueid === id) {
                return item;
            }
            return null;
        });
        return league_arr.length;
    }

    function activeSubMenuItem(id) {
        let arr = [...proLeagues];
        let league_arr = arr.map(item => {
            if (item.leagueid === id) {
                item.active = true;
            } else {
                item.active = false;
            }
            return item;
        });
        getId(id);
        setProLeagues(league_arr);
    }

    return (
        <aside className="gg-left-sidebar">
            <CSSTransition
                nodeRef={sidebarMenu}
                in={showSidebar}
                timeout={5000}
                className="sidebar-menu"
            >
                <ul ref={sidebarMenu} className="sidebar-menu">
                <li className="menu-item">
                    <span
                        className="menu-link active"
                        onClick={() => activeSubMenuItem('all')}
                    >
                        <svg className="menu-icon" width="20" height="20" viewBox="0 0 80 80">
                            <use xlinkHref="#esports_dota_2_81226" />
                        </svg>
                        <span className="menu-text">Dota 2<b id="dota_matches_count" className="count">{proMatches.length}</b></span>
                    </span>
                    <SlideDown>{
                        proLeagues.length ? (
                            <ul id="dota_leagues" className="sub-menu">{
                                proLeagues.map(item => (
                                    <li key={item.match_id} className="sub-item">{
                                        item.active ? (
                                            <span className="sub-link active">
                                        <span className="title">{item.league_name}</span>
                                        <span className="game-count">{getMatchesCount(proMatches, item.leagueid)}</span>
                                    </span>
                                        ) : (
                                            <a
                                                className="sub-link"
                                                href={item.leagueid}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    activeSubMenuItem(item.leagueid);
                                                }}
                                            >
                                                <span className="title">{item.league_name}</span>
                                                <span className="game-count">{getMatchesCount(proMatches, item.leagueid)}</span>
                                            </a>
                                        )
                                    }</li>
                                ))
                            }</ul>
                        ) : null
                    }</SlideDown>
                </li>
            </ul>
            </CSSTransition>
        </aside>
    )
}

export default LeftSidebar;